import { render, staticRenderFns } from "./TxtError.vue?vue&type=template&id=32334292&functional=true&"
import script from "./TxtError.vue?vue&type=script&lang=js&"
export * from "./TxtError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports